import React from "react";
import RadioButton from "./radioButton";

interface Props {
    value: string | null,
    onChange: (type: typeof Maschio) => void;
}
const Maschio = { key: "M", value: "Maschio" };
const Femmina = { key: "F", value: "Femmina" };
export default class GenderSelector extends React.PureComponent<Props>{
    render() {
        const { onChange, value } = this.props;
        return (
            <div className="d-flex">
                <RadioButton
                    style={{ marginRight: 5 }}
                    checked={value == "M"}
                    label="Maschio"
                    onChange={c => c && onChange(Maschio)}
                    name="gender"
                />
                <RadioButton
                    checked={value == "F"}
                    label="Femmina"
                    onChange={c => c && onChange(Femmina)}
                    name="gender"
                />
            </div>
        );
    }
}
